module.exports = __webpack_public_path__ + "img/minus-disabled.0e63b536.png";